<template>
  <a-modal
    :title="formTitle || '新增角色'"
    v-model:visible="open"
    @cancel="cancel"
    :width="800"
    :maskClosable="false"
    :keyboard="false"
    :destroyOnClose="true"
    :footer="null"
    class="create-form-modal"
  >
    <a-alert
      v-if="role === 'admin'"
      message="超级管理员角色信息 不可更改"
      banner
      style="margin-bottom: 16px"
    />
    <a-form
      ref="formRef"
      :model="form"
      :rules="rules"
      :label-col="{ flex: '0 0 150px' }"
      :wrapper-col="{ flex: '1 1 auto' }"
    >
      <a-form-item label="角色名称" name="roleName">
        <a-input v-model:value="form.roleName" placeholder="请输入" />
      </a-form-item>
      <a-form-item name="roleKey">
        <template v-slot:label>
          <span>
            权限字符
            <a-tooltip>
              <template v-slot:title>
                控制器中定义的权限字符，如：@PreAuthorize(`@ss.hasRole('admin')`)
              </template>
              <QuestionCircleOutlined />
            </a-tooltip>
          </span>
        </template>
        <a-input v-model:value="form.roleKey" placeholder="请输入" />
      </a-form-item>
      <a-form-item label="排序" name="roleSort">
        <a-input-number
          placeholder="请输入"
          v-model:value="form.roleSort"
          :min="0"
          style="width: 100%"
        />
      </a-form-item>
      <a-form-item label="状态" name="status">
        <a-radio-group v-model:value="form.status" button-style="solid">
          <a-radio-button :value="1">正常</a-radio-button>
          <a-radio-button :value="0">禁用</a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="菜单权限">
        <a-checkbox @change="handleCheckedTreeExpand($event)">
          展开/折叠
        </a-checkbox>
        <a-checkbox @change="handleCheckedTreeNodeAll($event)">
          全选/全不选
        </a-checkbox>
        <a-checkbox
          @change="handleCheckedTreeConnect($event)"
          :checked="form.menuCheckStrictly"
          :disabled="menuCheckedKeys.length > 0"
        >
          父子联动
          <a-tooltip>
            <template v-slot:title>
              当勾选项为空时方可切换模式， 可以点击"全不选"后再次切换。
            </template>
            <QuestionCircleOutlined />
          </a-tooltip>
        </a-checkbox>
        <a-tree
          v-model:checkedKeys="menuCheckedKeys"
          checkable
          :checkStrictly="!form.menuCheckStrictly"
          :expanded-keys="menuExpandedKeys"
          :auto-expand-parent="autoExpandParent"
          :tree-data="menuOptions"
          @check="onCheck"
          @expand="onExpandMenu"
          :replaceFields="defaultProps"
        />
      </a-form-item>
      <a-form-item label="备注" name="remark">
        <a-input
          v-model:value="form.remark"
          placeholder="请输入"
          type="textarea"
          allow-clear
        />
      </a-form-item>
      <div class="bottom-control" v-if="role !== 'admin'">
        <a-space>
          <a-button @click="cancel" class="cancel-btn"> 取消 </a-button>
          <a-button type="primary" :loading="submitLoading" @click="submitForm" class="save-btn">
            保存
          </a-button>
        </a-space>
      </div>
    </a-form>
  </a-modal>
</template>

<script>
import { QuestionCircleOutlined } from '@ant-design/icons-vue'
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'

import { getRole, addRole, updateRole } from '@/api/system/role'
import {
  treeselect as menuTreeselect,
  roleMenuTreeselect,
} from '@/api/system/menu'
import { treeFindParentIds, findAllIDs } from '@/utils/ruoyi'

export default {
  components: {
    QuestionCircleOutlined,
  },
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  components: {},
  data() {
    return {
      submitLoading: false,
      menuExpandedKeys: [],
      autoExpandParent: false,
      menuCheckedKeys: [],
      halfCheckedKeys: [],
      menuOptions: [],
      formTitle: '',
      role: '', // 角色如果是admin的话，不显示保存按钮
      // 表单参数
      form: {
        id: undefined,
        roleName: undefined,
        roleKey: undefined,
        roleSort: 0,
        status: 1,
        menuIds: [],
        menuCheckStrictly: true,
        remark: undefined,
      },
      open: false,
      menuExpand: false,
      menuNodeAll: false,
      rules: {
        roleName: [
          { required: true, message: '角色名称不能为空', trigger: 'blur' },
        ],
        roleKey: [
          { required: true, message: '权限字符不能为空', trigger: 'blur' },
        ],
        roleSort: [
          { required: true, message: '显示顺序不能为空', trigger: 'blur' },
        ],
      },
      defaultProps: {
        children: 'children',
        title: 'label',
        key: 'id',
      },
    }
  },
  created() {},
  mounted() {
    console.log('statusOptions', this.statusOptions)
  },
  computed: {},
  watch: {},
  methods: {
    onExpandMenu(expandedKeys) {
      this.menuExpandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    /** 查询菜单树结构 */
    getMenuTreeselect() {
      menuTreeselect().then((response) => {
        this.menuOptions = response.data
      })
    },
    // 所有菜单节点数据
    getMenuAllCheckedKeys() {
      // 全选与半选
      return this.menuCheckedKeys.concat(this.halfCheckedKeys)
    },
    getAllMenuNode(nodes) {
      if (!nodes || nodes.length === 0) {
        return []
      }
      nodes.forEach((node) => {
        this.menuCheckedKeys.push(node.id)
        return this.getAllMenuNode(node.children)
      })
    },
    handleCheckedTreeNodeAll(value) {
      if (value.target.checked) {
        this.getAllMenuNode(this.menuOptions)
      } else {
        this.menuCheckedKeys = []
        this.halfCheckedKeys = []
      }
    },
    handleCheckedTreeExpand(value) {
      if (value.target.checked) {
        const treeList = this.menuOptions
        for (let i = 0; i < treeList.length; i++) {
          this.menuExpandedKeys.push(treeList[i].id)
        }
      } else {
        this.menuExpandedKeys = []
      }
    },
    // 树权限（父子联动）
    handleCheckedTreeConnect(value) {
      this.form.menuCheckStrictly = !this.form.menuCheckStrictly
    },
    /** 根据角色ID查询菜单树结构 */
    getRoleMenuTreeselect(roleId) {
      return roleMenuTreeselect(roleId).then((response) => {
        this.menuOptions = response.data.menus
        return response.data
      })
    },
    onCheck(checkedKeys, info) {
      if (!this.form.menuCheckStrictly) {
        let currentCheckedKeys = []
        if (this.menuCheckedKeys.checked) {
          currentCheckedKeys = currentCheckedKeys.concat(
            this.menuCheckedKeys.checked
          )
        }
        if (this.menuCheckedKeys.halfChecked) {
          currentCheckedKeys = currentCheckedKeys.concat(
            this.menuCheckedKeys.halfChecked
          )
        }
        this.menuCheckedKeys = currentCheckedKeys
      } else {
        // 半选节点
        this.halfCheckedKeys = info.halfCheckedKeys
        this.menuCheckedKeys = checkedKeys
      }
    },
    onClose() {
      this.open = false
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },
    // 表单重置
    reset() {
      if (this.$refs.menu !== undefined) {
        this.menuCheckedKeys = []
        this.halfCheckedKeys = []
      }
      this.menuExpand = false
      this.menuNodeAll = false
      this.menuExpandedKeys = []
      this.autoExpandParent = false
      this.menuCheckedKeys = []
      this.halfCheckedKeys = []
      this.form = {
        id: undefined,
        roleName: undefined,
        roleKey: undefined,
        roleSort: 0,
        status: 1,
        menuIds: [],
        menuCheckStrictly: true,
        remark: undefined,
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.getMenuTreeselect()
      this.open = true
      this.formTitle = '添加角色'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const roleId = row ? row.id : ids
      const roleMenu = this.getRoleMenuTreeselect(roleId)
      getRole(roleId).then((response) => {
        const data = response.data || {}
        // 直接赋值表单数据，确保状态字段是数字类型
        this.form = {
          id: data.id,
          roleName: data.roleName,
          roleKey: data.roleKey,
          roleSort: data.roleSort !== undefined && data.roleSort !== null ? Number(data.roleSort) : 0,
          status: data.status !== undefined && data.status !== null 
            ? (typeof data.status === 'string' ? parseInt(data.status) : Number(data.status))
            : 1,
          menuIds: data.menuIds || [],
          menuCheckStrictly: data.menuCheckStrictly !== undefined ? data.menuCheckStrictly : true,
          remark: data.remark,
        }
        this.role = data.roleKey
        this.formTitle = '修改角色'
        this.open = true
        this.$nextTick(() => {
          // 清除表单验证状态
          if (this.$refs.formRef) {
            this.$refs.formRef.clearValidate()
          }
          // 等待菜单数据加载完成后再设置 checkedKeys
          roleMenu.then((res) => {
            // menuOptions 已经在 getRoleMenuTreeselect 中设置完成
            // 通过 checkedKeys 回显菜单权限数据
            let checkedKeys = res.checkedKeys || []
            // 如果是超级管理员角色，所有菜单全部选中
            if (data.roleKey === 'admin') {
              checkedKeys = findAllIDs(this.menuOptions)
            }
            // 在下一个 tick 中设置，确保树组件已经渲染完成
            this.$nextTick(() => {
              // 直接赋值数组
              this.menuCheckedKeys = checkedKeys
            })
          })
        })
      })
    },
    /** 提交按钮 */
    submitForm: async function () {
      try {
        await this.$refs.formRef.validate()
        if (this.form.id !== undefined) {
          this.form.menuIds = this.getMenuAllCheckedKeys()
          const res = await updateRole(this.form)
          if (res.success) {
            this.$message.success('修改成功', 3)
            this.open = false
            $emit(this, 'ok')
          } else {
            this.$message.error(`修改失败，${res.message}`)
          }
        } else {
          this.form.menuIds = this.getMenuAllCheckedKeys()
          await addRole(this.form)
          this.$message.success('新增成功', 3)
          this.open = false
          $emit(this, 'ok')
        }
      } catch (error) {
        return false
      } finally {
        this.submitLoading = false
      }
    },
  },
  emits: ['ok', 'close'],
}
</script>

<style scoped>
/* 按钮样式 */
.save-btn {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.save-btn:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

.save-btn:focus {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

.save-btn:active {
  background-color: #0E4ACC !important;
  border-color: #0E4ACC !important;
  color: #FFFFFF !important;
}

.cancel-btn {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
  border-radius: 4px !important;
}

.cancel-btn:hover {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
}

.bottom-control {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 24px;
  margin-bottom: 0;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}
</style>

<style>
/* Modal body 样式 */
.create-form-modal .ant-modal-body {
  max-height: 70vh;
  overflow-y: auto;
  padding: 20px 16px 16px 16px !important;
}

.create-form-modal .ant-form-item {
  margin-bottom: 16px;
}

.create-form-modal .ant-form-item-label {
  padding-bottom: 6px;
  flex: 0 0 150px !important;
  max-width: 150px !important;
}

.create-form-modal .ant-form-item-label > label {
  width: 100%;
  text-align: right;
  justify-content: flex-end;
}

.create-form-modal .ant-form-item-control {
  flex: 1;
  min-width: 0;
}

/* 输入框样式 - 圆角和边框 */
.create-form-modal .ant-input,
.create-form-modal .ant-input:hover,
.create-form-modal .ant-input:focus {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.create-form-modal .ant-input-affix-wrapper,
.create-form-modal .ant-input-affix-wrapper:hover,
.create-form-modal .ant-input-affix-wrapper-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.create-form-modal .ant-input-affix-wrapper .ant-input {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 选择框样式 */
.create-form-modal .ant-select-selector,
.create-form-modal .ant-select-selector:hover,
.create-form-modal .ant-select-focused .ant-select-selector {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 日期选择器样式 */
.create-form-modal .ant-picker,
.create-form-modal .ant-picker:hover,
.create-form-modal .ant-picker-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 数字输入框样式 */
.create-form-modal .ant-input-number,
.create-form-modal .ant-input-number:hover,
.create-form-modal .ant-input-number-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 按钮保持圆角 */
.create-form-modal .ant-btn {
  border-radius: 4px !important;
}

/* Radio Button 样式 - 状态 */
.create-form-modal .ant-radio-button-wrapper {
  border-radius: 4px !important;
}

.create-form-modal .ant-radio-button-wrapper:first-child {
  border-radius: 4px 0 0 4px !important;
}

.create-form-modal .ant-radio-button-wrapper:last-child {
  border-radius: 0 4px 4px 0 !important;
}

.create-form-modal .ant-radio-button-wrapper-checked {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
  outline: none !important;
}

.create-form-modal .ant-radio-button-wrapper-checked:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
  outline: none !important;
}

.create-form-modal .ant-radio-button-wrapper-checked:focus {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
  outline: none !important;
}

.create-form-modal .ant-radio-button-wrapper-checked:focus-within {
  box-shadow: none !important;
  outline: none !important;
}

.create-form-modal .ant-radio-button-wrapper-checked::before {
  background-color: #165DFF !important;
}

.create-form-modal .ant-radio-button-wrapper-checked:active {
  border-color: #165DFF !important;
  box-shadow: none !important;
  outline: none !important;
}
</style>
